import { useQuery } from '@tanstack/react-query';

import { gqlClient } from '@/api/graphql-client';
import { graphql } from '@/gql';
import projectKeys from './keyFactory';

const SearchProjectsQuery = graphql(`
  query SearchProjects(
    $input: GetProjectsInput
    $pagination: PaginationInput!
  ) {
    projects(input: $input, pagination: $pagination) {
      items {
        publicId
        reference
        customer {
          name
        }
      }
    }
  }
`);

const SEARCH_PROJECTS_LIMIT = 20;

const useSearchProjects = (searchTerm: string) => {
  const { data, ...rest } = useQuery({
    queryKey: projectKeys.search(searchTerm),
    queryFn: () => {
      return gqlClient.request(SearchProjectsQuery, {
        input: { searchTerm: searchTerm || undefined },
        pagination: { limit: SEARCH_PROJECTS_LIMIT, offset: 0 },
      });
    },
  });

  return {
    projects: data?.projects.items,
    data,
    ...rest,
  };
};

export default useSearchProjects;
